import { render, staticRenderFns } from "./WaitingScreen.vue?vue&type=template&id=556f5c48&scoped=true&"
import script from "./WaitingScreen.vue?vue&type=script&lang=js&"
export * from "./WaitingScreen.vue?vue&type=script&lang=js&"
import style0 from "./WaitingScreen.vue?vue&type=style&index=0&id=556f5c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556f5c48",
  null
  
)

export default component.exports